import { CSSProperties } from 'react';
import { SAILogo, SText } from '@setvi/shared/components';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { CheckIconV2, GradientSpinner } from '@setvi/shared/components/sicons';
import {
  Bullet,
  BulletContainer,
  FooterContainer,
  HeaderText,
  IconContainer,
  LoaderContainer,
  StepIconContainer,
  StepItem,
  StepsContainer,
  StepText
} from './styled';
import { useProductLoader } from './hook';

interface ProductLoaderProps {
  statusId?: string;
  containerStyle?: CSSProperties;
  stepsContainerStyle?: CSSProperties;
}

const ProductLoader = ({
  statusId,
  containerStyle,
  stepsContainerStyle
}: ProductLoaderProps) => {
  const { user } = useAppContext();
  const { currentStep, completedSteps, loaderSteps } = useProductLoader({
    statusId
  });

  return (
    <LoaderContainer style={containerStyle}>
      <HeaderText>
        Hang tight {user?.FirstName || ''}, we’re finding the best match for
        you...
      </HeaderText>

      <StepsContainer style={stepsContainerStyle}>
        {loaderSteps.map((step, index) => {
          const isCompleted = completedSteps.includes(index);
          const isActive = currentStep === index;

          let stepText = step.initial;
          let icon = (
            <BulletContainer width={20} height={20}>
              <Bullet />
            </BulletContainer>
          );
          if (isCompleted) {
            stepText = step.completed;
            icon = (
              <IconContainer>
                <CheckIconV2
                  fill="#fff"
                  style={{
                    width: 16,
                    height: 16
                  }}
                />
              </IconContainer>
            );
          } else if (isActive) {
            stepText = step.progress;
            icon = <GradientSpinner key={step?.key} />;
          }

          return (
            <StepItem key={step?.key}>
              <StepIconContainer>{icon}</StepIconContainer>
              <StepText isActive={isActive} isCompleted={isCompleted}>
                {stepText}
              </StepText>
            </StepItem>
          );
        })}
      </StepsContainer>

      <FooterContainer>
        <SText
          noLineClamp
          fontColor="#5D7083"
          style={{
            fontSize: 15,
            letterSpacing: 0
          }}>
          This usually takes 7 - 10 seconds.
        </SText>
        <SText
          noLineClamp
          fontColor="#5D7083"
          style={{
            fontSize: 15,
            letterSpacing: 0,
            marginBottom: 20
          }}>
          Thanks for your patience - smarter recommendations take a few extra
          moments 🧠✨
        </SText>
        <SAILogo />
      </FooterContainer>
    </LoaderContainer>
  );
};

export default ProductLoader;
